import React from 'react';

function Blogs() {
  return (
    <section className="blog-main blog section-padding">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-4">
            <div className="item mb-50">
              <div className="img fit-img">
                <img src="/assets/imgs/blog/1.jpg" alt="" />
              </div>
              <div className="cont pt-40">
                <div className="info sub-title p-color d-flex align-items-center mb-15">
                  <div>
                    <a href="/blog-grid-sidebar">By : Admin</a>
                  </div>
                  <div className="ml-30">
                    <a href="/blog-grid-sidebar">August 14, 2023</a>
                  </div>
                </div>
                <h4 className="fz-30">
                  Design Inspiration: Where to Find Creative Ideas
                </h4>
                <a
                  href="/blog-details"
                  className="butn-crev d-flex align-items-center mt-40"
                >
                  <span className="hover-this">
                    <span className="circle hover-anim">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </span>
                  <span className="text">Read more</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item mb-50">
              <div className="img fit-img">
                <img src="/assets/imgs/blog/2.jpg" alt="" />
              </div>
              <div className="cont pt-40">
                <div className="info sub-title p-color d-flex align-items-center mb-15">
                  <div>
                    <a href="/blog-grid-sidebar">By : Admin</a>
                  </div>
                  <div className="ml-30">
                    <a href="/blog-grid-sidebar">August 14, 2023</a>
                  </div>
                </div>
                <h4 className="fz-30">
                  Typography: Choosing Fonts for Maximum Impact
                </h4>
                <a
                  href="/blog-details"
                  className="butn-crev d-flex align-items-center mt-40"
                >
                  <span className="hover-this">
                    <span className="circle hover-anim">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </span>
                  <span className="text">Read more</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item mb-50">
              <div className="img fit-img">
                <img src="/assets/imgs/blog/3.jpg" alt="" />
              </div>
              <div className="cont pt-40">
                <div className="info sub-title p-color d-flex align-items-center mb-15">
                  <div>
                    <a href="/blog-grid-sidebar">By : Admin</a>
                  </div>
                  <div className="ml-30">
                    <a href="/blog-grid-sidebar">August 14, 2023</a>
                  </div>
                </div>
                <h4 className="fz-30">
                  Design Inspiration: Where to Find Creative Ideas
                </h4>
                <a
                  href="/blog-details"
                  className="butn-crev d-flex align-items-center mt-40"
                >
                  <span className="hover-this">
                    <span className="circle hover-anim">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </span>
                  <span className="text">Read more</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item md-mb50">
              <div className="img fit-img">
                <img src="/assets/imgs/blog/2.jpg" alt="" />
              </div>
              <div className="cont pt-40">
                <div className="info sub-title p-color d-flex align-items-center mb-15">
                  <div>
                    <a href="/blog-grid-sidebar">By : Admin</a>
                  </div>
                  <div className="ml-30">
                    <a href="/blog-grid-sidebar">August 14, 2023</a>
                  </div>
                </div>
                <h4 className="fz-30">
                  Typography: Choosing Fonts for Maximum Impact
                </h4>
                <a
                  href="/blog-details"
                  className="butn-crev d-flex align-items-center mt-40"
                >
                  <span className="hover-this">
                    <span className="circle hover-anim">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </span>
                  <span className="text">Read more</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item sm-mb50">
              <div className="img fit-img">
                <img src="/assets/imgs/blog/1.jpg" alt="" />
              </div>
              <div className="cont pt-40">
                <div className="info sub-title p-color d-flex align-items-center mb-15">
                  <div>
                    <a href="/blog-grid-sidebar">By : Admin</a>
                  </div>
                  <div className="ml-30">
                    <a href="/blog-grid-sidebar">August 14, 2023</a>
                  </div>
                </div>
                <h4 className="fz-30">
                  Design Inspiration: Where to Find Creative Ideas
                </h4>
                <a
                  href="/blog-details"
                  className="butn-crev d-flex align-items-center mt-40"
                >
                  <span className="hover-this">
                    <span className="circle hover-anim">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </span>
                  <span className="text">Read more</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item">
              <div className="img fit-img">
                <img src="/assets/imgs/blog/3.jpg" alt="" />
              </div>
              <div className="cont pt-40">
                <div className="info sub-title p-color d-flex align-items-center mb-15">
                  <div>
                    <a href="/blog-grid-sidebar">By : Admin</a>
                  </div>
                  <div className="ml-30">
                    <a href="/blog-grid-sidebar">August 14, 2023</a>
                  </div>
                </div>
                <h4 className="fz-30">
                  Typography: Choosing Fonts for Maximum Impact
                </h4>
                <a
                  href="/blog-details"
                  className="butn-crev d-flex align-items-center mt-40"
                >
                  <span className="hover-this">
                    <span className="circle hover-anim">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </span>
                  <span className="text">Read more</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blogs;
